import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import { PermissionConsts } from '@shared/permission-consts';

export const loginRedirectGuard: CanActivateFn = () => {
    const permissionChecker = inject(PermissionCheckerService);
    const router = inject(Router);

    const target = permissionChecker.isGranted(PermissionConsts.Pages_MyPaperwork) ? 'app/myprofile/paperworks' : 'app/paperworks';

    return router.createUrlTree([target]);
};
